<div class="modal fade" id="kt_modal_add_sales_commission" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-500px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Add Sales Commission for Invoice No: #{{ invoiceNumber }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>
      <form [formGroup]="commissionForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Sales Commission Amount -->
            <div class="col-12 mb-5">
              <label class="required form-label">Sales Commission Amount (JPY)</label>
              <input type="number"
                     class="form-control form-control-solid"
                     formControlName="salesCommissionAmount"
                     placeholder="Enter commission amount"
                     min="0"
                     step="0.01" />
              <div class="fv-plugins-message-container">
                <div class="fv-help-block"
                     *ngIf="commissionForm.get('salesCommissionAmount')?.invalid && commissionForm.get('salesCommissionAmount')?.touched">
                  <span *ngIf="commissionForm.get('salesCommissionAmount')?.errors?.['required']">
                    Sales commission amount is required
                  </span>
                  <span *ngIf="commissionForm.get('salesCommissionAmount')?.errors?.['min']">
                    Amount must be greater than or equal to 0
                  </span>
                </div>
              </div>
            </div>

            <!-- Sales Commission Date -->
            <div class="col-12 mb-5">
              <label class="required form-label">Sales Commission Date</label>
              <input type="date"
                     class="form-control form-control-solid"
                     formControlName="salesCommissionDate"
                     placeholder="Select commission date" />
              <div class="fv-plugins-message-container">
                <div class="fv-help-block"
                     *ngIf="commissionForm.get('salesCommissionDate')?.invalid && commissionForm.get('salesCommissionDate')?.touched">
                  <span *ngIf="commissionForm.get('salesCommissionDate')?.errors?.['required']">
                    Sales commission date is required
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" (click)="onCancel()">Cancel</button>
          <button type="submit"
                  class="btn btn-primary indicator"
                  style="min-width: 150px;"
                  [disabled]="commissionForm.invalid || isLoading">
            <!--begin::Indicator label-->
            <span class="indicator-label" *ngIf="!isLoading">Save</span>
            <!--end::Indicator label-->
            <!--begin::Indicator progress-->
            <span class="indicator-progress" *ngIf="isLoading">
              <span class="spinner-border spinner-border-sm align-middle me-2"></span>
              Please wait...
            </span>
            <!--end::Indicator progress-->
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
